/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ImpersonateInputs */

const th_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวมสิทธิ์`)
};

const en_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impersonate`)
};

const ja_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理表示`)
};

const zh_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以其身份查看`)
};

const es_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suplantar`)
};

const pt_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personificar`)
};

const id_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyamar`)
};

const fr_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usurper`)
};

const tl_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magpanggap`)
};

const vi_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mạo danh`)
};

const ko_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다른 사용자로 보기`)
};

const de_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identität wechseln`)
};

const ru_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти от его имени`)
};

const tr_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimliğine bürün`)
};

const it_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impersona`)
};

const pl_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wciel się`)
};

const uk_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійти від його імені`)
};

const hi_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इनके रूप में देखें`)
};

const ar_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتحال الهوية`)
};

const ms_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyamar`)
};

const bn_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরিচয়ে দেখুন`)
};

const zh_tw2_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以其身分檢視`)
};

const zh_hk2_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以其身分檢視`)
};

const ur_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حیثیت اختیار کریں`)
};

const fa_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دیدن به نام او`)
};

const sw_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia kwa jina lake`)
};

const nl_impersonate = /** @type {(inputs: ImpersonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijken als`)
};

/**
* | output |
* | --- |
* | "Impersonate" |
*
* @param {ImpersonateInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const impersonate = /** @type {((inputs?: ImpersonateInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ImpersonateInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_impersonate(inputs)
	if (locale === "ja") return ja_impersonate(inputs)
	if (locale === "zh") return zh_impersonate(inputs)
	if (locale === "es") return es_impersonate(inputs)
	if (locale === "pt") return pt_impersonate(inputs)
	if (locale === "id") return id_impersonate(inputs)
	if (locale === "fr") return fr_impersonate(inputs)
	if (locale === "tl") return tl_impersonate(inputs)
	if (locale === "vi") return vi_impersonate(inputs)
	if (locale === "ko") return ko_impersonate(inputs)
	if (locale === "de") return de_impersonate(inputs)
	if (locale === "ru") return ru_impersonate(inputs)
	if (locale === "tr") return tr_impersonate(inputs)
	if (locale === "it") return it_impersonate(inputs)
	if (locale === "pl") return pl_impersonate(inputs)
	if (locale === "uk") return uk_impersonate(inputs)
	if (locale === "hi") return hi_impersonate(inputs)
	if (locale === "ar") return ar_impersonate(inputs)
	if (locale === "ms") return ms_impersonate(inputs)
	if (locale === "bn") return bn_impersonate(inputs)
	if (locale === "zh-TW") return zh_tw2_impersonate(inputs)
	if (locale === "zh-HK") return zh_hk2_impersonate(inputs)
	if (locale === "ur") return ur_impersonate(inputs)
	if (locale === "fa") return fa_impersonate(inputs)
	if (locale === "sw") return sw_impersonate(inputs)
	if (locale === "nl") return nl_impersonate(inputs)
	return en_impersonate(inputs)
});